import CancelC1Qry from 'view/projects/CancelC1Qry';
import GoodsListQry from 'view/projects/GoodsListQry';
import ExpGciQry from 'view/projects/ExpGciQry';
import ExpInOutC2C3 from 'view/projects/ExpInOutC2C3';
import ExpNotGcoQry from 'view/projects/ExpNotGcoQry';
import ExpNotInQry from 'view/projects/ExpNotInQry';
import ExpTaxBillQry from 'view/projects/ExpTaxBillQry';
import ExpTaxDetailQry from 'view/projects/ExpTaxDetailQry';
import expTaxRecp from 'view/projects/ExpTaxRecpQry';
import RptInOutDailyQry from 'view/projects/RptInOutDailyQry';
import InspectQry from 'view/projects/InspectQry';
import ShiftGoodsList from 'view/projects/ShiftGoodsList';
import BackClearanceList from 'view/projects/BackClearanceList';
import VoyageQry from 'view/projects/VoyageQry';
import MawbStatQry from 'view/projects/MawbStatQry';
import HawbQry from 'view/projects/HawbQry';
import MawbQry from 'view/projects/MawbQry';
import RptDownload from 'view/projects/RptDownload';
import DeclQry from 'view/projects/DeclQry';
import AspUserMtn from 'view/projects/AspUserMtn';
import ManifestQry from 'view/projects/ManifestQry';
import InOutStatQry from 'view/projects/InOutStatQry';
import DutyNoQryDld from 'view/projects/DutyNoQryDld';
import RptManifestNoInQry from 'view/projects/RptManifestNoInQry';
import RptNmNdLogQry from 'view/projects/RptNmNdLogQry';
import EmptyPage from 'view/empty';
import Login from 'view/login';
import ExpTaxRecpSet from 'view/projects/ExpTaxRecpSet';
import ManifDeclMwbQry from 'view/projects/ManifDeclMwbQry';
import CtnrUnloadListMtn from 'view/projects/CtnrUnloadListMtn';
import DevaningPlanMtn from 'view/projects/DevaningPlanMtn';
import MisInOutStatQry from 'view/projects/MisInOutStatQry';
import DevaningPlanQry from 'view/projects/DevaningPlanQry';
import CargoUnpackingSeqQry from 'view/projects/CargoUnpackingSeqQry';
import UploadOpenCtnrImg from 'view/projects/UploadOpenCtnrImg';
import OpenCtnrImgMtn from 'view/projects/OpenCtnrImgMtn';
import CtgdsStatusMtn from 'view/projects/CtgdsStatusMtn';
import StorageAreaMtn from 'view/projects/StorageAreaMtn';
import StorageLocationMtn from 'view/projects/StorageLocationMtn';
import ACInOutDetailQry from 'view/projects/ACInOutDetailQry';
import GoodsPositionMtn from 'view/projects/GoodsPositionMtn';
import TmpStorageGoodsMtn from 'view/projects/TmpStorageGoodsMtn';
import ACInOutSummaryQry from 'view/projects/ACInOutSummaryQry';
import InvoiceQry from 'view/projects/InvoiceQry';
import InvCompare2DeclQry from 'view/projects/InvCompare2DeclQry';
import ShortOverLandedQry from 'view/projects/ShortOverLandedQry';
import CarRegisterMtn from 'view/projects/CarRegisterMtn';
import CarRegisterToWhitelistMtn from 'view/projects/CarRegisterToWhitelistMtn';
import WaybillDataQry from 'view/projects/WaybillDataQry';
import WhitelistCarRegisterMtn from 'view/projects/WhitelistCarRegisterMtn';
import ChangePwdMtn from 'view/projects/ChangePwdMtn';

const indexRouter = [
  // 主提單查詢
  { path: '/MawbQry', component: MawbQry },
  // 分提單查詢
  { path: '/HawbQry', component: HawbQry },
  // 報單號碼查詢
  { path: '/DeclQry', component: DeclQry },
  // 主提單貨物統計資料查詢
  { path: '/MawbStatQry', component: MawbStatQry },
  // 01.已進倉未出倉查詢
  { path: '/ExpGciQry', component: ExpGciQry },
  // 02.已放行未出倉清單
  { path: '/ExpNotGcoQry', component: ExpNotGcoQry },
  // 03.已進倉C2-C3未放行清表
  { path: '/ExpInOutC2C3', component: ExpInOutC2C3 },
  // 04.進口收據資料查詢
  { path: '/ExpTaxRecpQry', component: expTaxRecp },
  // 05. 稅費明細查詢
  { path: '/ExpTaxDetailQry', component: ExpTaxDetailQry },
  // 06. 進出倉交接表
  { path: '/RptInOutDailyQry', component: RptInOutDailyQry },
  // 07. 進口稅費繳納資料查詢
  { path: '/ExpTaxBillQry', component: ExpTaxBillQry },
  // 已申報未入倉清單
  { path: '/ExpNotInQry', component: ExpNotInQry },
  // C1取消放行查詢
  { path: '/CancelC1Qry', component: CancelC1Qry },
  // 貨物進出明細表
  { path: '/GoodsListQry', component: GoodsListQry },
  // 查驗貨物清表
  { path: '/InspectQry', component: InspectQry },
  // 移倉_鎖定_查扣作業查詢
  { path: '/ShiftGoodsList', component: ShiftGoodsList },
  // 退關_退運作業查詢
  { path: '/BackClearanceList', component: BackClearanceList },
  // 船班貨物清單查詢
  { path: '/VoyageQry', component: VoyageQry },
  // 使用者功能權限設定作業
  { path: '/AspUserMtn', component: AspUserMtn },
  // 下載
  { path: '/RptDownload', component: RptDownload },
  // 進口艙單資料查詢
  { path: '/ManifestQry', component: ManifestQry },
  // 進出倉貨量統計表
  { path: '/InOutStatQry', component: InOutStatQry },
  // 艙報單主號差異表
  { path: '/ManifDeclMwbQry', component: ManifDeclMwbQry },
  // 調閱電子稅單
  { path: '/DutyNoQryDld', component: DutyNoQryDld },
  // 前倉作業異常報表查詢
  { path: '/RptNmNdLogQry', component: RptNmNdLogQry },
  // 稅單收據資料設定
  { path: '/ExpTaxRecpSet', component: ExpTaxRecpSet },
  // 艙報單已申報此分號無刷碼記錄查詢
  { path: '/RptManifestNoInQry', component: RptManifestNoInQry },
  // 貨櫃卸存清單維護
  { path: '/CtnrUnloadListMtn', component: CtnrUnloadListMtn },
  // 拆櫃預定表維護
  { path: '/DevaningPlanMtn', component: DevaningPlanMtn },
  // 進出倉貨量統計表
  { path: '/MisInOutStatQry', component: MisInOutStatQry },
  // 拆櫃預定表查詢
  { path: '/DevaningPlanQry', component: DevaningPlanQry },
  // 現場貨物拆櫃順序表
  { path: '/CargoUnpackingSeqQry', component: CargoUnpackingSeqQry },
  // 開櫃影像上傳
  { path: '/UploadOpenCtnrImg', component: UploadOpenCtnrImg },
  // 開櫃影像查詢
  { path: '/OpenCtnrImgMtn', component: OpenCtnrImgMtn },
  // 貨櫃動態維護
  { path: '/CtgdsStatusMtn', component: CtgdsStatusMtn },
  // // 移倉註記
  // { path: '/UploadOpenCtnrImg', component: UploadOpenCtnrImg },
  // // 放行狀態查詢
  // { path: '/UploadOpenCtnrImg', component: UploadOpenCtnrImg },
  // 儲區基本資料維護
  { path: '/StorageAreaMtn', component: StorageAreaMtn },
  // 儲位基本資料維護
  { path: '/StorageLocationMtn', component: StorageLocationMtn },
  // 人員進出歷程查詢
  { path: '/ACInOutDetailQry', component: ACInOutDetailQry },
  // 貨物儲位設定維護
  { path: '/GoodsPositionMtn', component: GoodsPositionMtn },
  // 人員進出彙總查詢
  { path: '/ACInOutSummaryQry', component: ACInOutSummaryQry },
  // 暫存貨物查詢
  { path: '/TmpStorageGoodsMtn', component: TmpStorageGoodsMtn },
  // 短溢卸報表
  { path: '/ShortOverLandedQry', component: ShortOverLandedQry },
  // 發票查詢
  { path: '/InvoiceQry', component: InvoiceQry },

  { path: '/InvCompare2DeclQry', component: InvCompare2DeclQry },

  // 車輛入出站登錄維護
  { path: '/CarRegisterMtn', component: CarRegisterMtn },

  // 車輛入出站登錄查詢與上傳
  { path: '/CarRegisterToWhitelistMtn', component: CarRegisterToWhitelistMtn },

  // 運送單電子簽章調閱查詢
  { path: '/WaybillDataQry', component: WaybillDataQry },

  // 白名單車輛入出站登錄維護
  { path: '/WhitelistCarRegisterMtn', component: WhitelistCarRegisterMtn },

  { path: '/ChangePwdMtn', component: ChangePwdMtn },

  // 登入頁
  { path: '/login', component: Login },

  { path: '/', component: EmptyPage },
];

export default indexRouter;
